// extracted by mini-css-extract-plugin
module.exports = {"workSection":"projects-module--work-section--3aZbf","workSectionTableFootnote":"projects-module--work-section-table-footnote--2KTHg"};